// Mailchimp configuration
// You'll need to get these values from your Mailchimp account

export const mailchimpConfig = {
    // Your Mailchimp form action URL (changed to post-json for JSONP)
    url: "https://atlasimprov.us8.list-manage.com/subscribe/post-json",

    // The 'u' parameter from your Mailchimp embedded form code
    u: "96d75a611b17cf43f44b208d9",

    // The 'id' parameter from your Mailchimp embedded form code (your list ID)
    id: "c1408ace5b"
};
